const styles = theme => ({
  container: {
    width: '100%',
    backgroundColor: theme.palette.primary.white,
    boxShadow: '0 -1px 8px rgba(0, 0, 0, 0.1)',
    padding: '16px 24px',
  },

  buttonsHolder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },

  btn: {
    height: '58px',
    padding: '16px 40px',
    '& span': {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
      textTransform: 'capitalize',
    },
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      '& span': {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '21px',
      },
    },
  },

  disabledBtn: {
    backgroundColor: `${theme.palette.primary.black20} !important`,
    color: `${theme.palette.primary.white} !important`,
    border: '0 !important',
  },
  previousButton: {
    backgroundColor: theme.palette.primary.white,
    color: theme.palette.primary.main,

    '&:hover': {
      backgroundColor: theme.palette.primary.white,
      color: theme.palette.primary.main,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.white,
      color: theme.palette.primary.main,
    },
  },
  nextButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,

    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
    },
  },

  rotateArrow: {
    '& img': {
      marginRight: '8px',
      transform: 'rotate(180deg)',
    },
  },
});

export default styles;
